import { formatInTimeZone } from "date-fns-tz";
import i18n from "i18next";

import { getDateFnsLocale } from "@/lib/date-fns-locale";
import type { AppLocale } from "@/lib/locale/resolve-effective-locale";

const AMS = "Europe/Amsterdam";

function formatForecastDateTime(iso: string, locale: AppLocale): string {
  return formatInTimeZone(new Date(iso), AMS, "EEEE d MMMM yyyy HH'.'mm 'uur'", {
    locale: getDateFnsLocale(locale),
  });
}

function formatForecastFooterDateTime(iso: string, locale: AppLocale): string {
  return formatInTimeZone(new Date(iso), AMS, "EEEE dd MMMM yyyy HH'.'mm 'uur'", {
    locale: getDateFnsLocale(locale),
  });
}

export function formatForecastIssued(iso: string, locale: AppLocale = "nl"): string {
  return i18n.t("widgets.maritime_forecast.issued", {
    date: formatForecastDateTime(iso, locale),
    lng: locale,
  });
}

export function formatForecastFooterLines(
  iso: string,
  locale: AppLocale = "nl",
): [string, string] {
  return [
    i18n.t("widgets.maritime_forecast.footer", {
      date: formatForecastFooterDateTime(iso, locale),
      lng: locale,
    }),
    i18n.t("widgets.maritime_forecast.footer_local_time_note", { lng: locale }),
  ];
}

/** @deprecated Use formatForecastIssued */
export const formatForecastIssuedNl = (iso: string) => formatForecastIssued(iso, "nl");

/** @deprecated Use formatForecastFooterLines */
export const formatForecastFooterLinesNl = (iso: string) =>
  formatForecastFooterLines(iso, "nl");
